import { loadOptions } from '../formset.js';

export default function (...args)
{
	return {
		/*
		options: [
			{ value: 'AC', label: 'Acre' },
			{ value: 'AL', label: 'Alagoas' },
			{ value: 'AM', label: 'Amazonas' },
			{ value: 'AP', label: 'Amapá' },
			{ value: 'BA', label: 'Bahia' },
			{ value: 'CE', label: 'Ceará' },
			{ value: 'DF', label: 'Distrito Federal' },
			{ value: 'ES', label: 'Espírito Santo' },
			{ value: 'GO', label: 'Goiás' },
			{ value: 'MA', label: 'Maranhão' },
			{ value: 'MT', label: 'Mato Grosso' },
			{ value: 'MS', label: 'Mato Grosso do Sul' },
			{ value: 'MG', label: 'Minas Gerais' },
			{ value: 'PA', label: 'Pará' },
			{ value: 'PB', label: 'Paraíba' },
			{ value: 'PR', label: 'Paraná' },
			{ value: 'PE', label: 'Pernambuco' },
			{ value: 'PI', label: 'Piauí' },
			{ value: 'RN', label: 'Rio Grande do Norte' },
			{ value: 'RS', label: 'Rio Grande do Sul' },
			{ value: 'RJ', label: 'Rio de Janeiro' },
			{ value: 'RO', label: 'Rondônia' },
			{ value: 'RR', label: 'Roraima' },
			{ value: 'SC', label: 'Santa Catarina' },
			{ value: 'SP', label: 'São Paulo' },
			{ value: 'SE', label: 'Sergipe' },
			{ value: 'TO', label: 'Tocantins' },
		],
		*/
		options: [
			{ value: 'AC', label: 'AC' },
			{ value: 'AL', label: 'AL' },
			{ value: 'AM', label: 'AM' },
			{ value: 'AP', label: 'AP' },
			{ value: 'BA', label: 'BA' },
			{ value: 'CE', label: 'CE' },
			{ value: 'DF', label: 'DF' },
			{ value: 'ES', label: 'ES' },
			{ value: 'GO', label: 'GO' },
			{ value: 'MA', label: 'MA' },
			{ value: 'MT', label: 'MT' },
			{ value: 'MS', label: 'MS' },
			{ value: 'MG', label: 'MG' },
			{ value: 'PA', label: 'PA' },
			{ value: 'PB', label: 'PB' },
			{ value: 'PR', label: 'PR' },
			{ value: 'PE', label: 'PE' },
			{ value: 'PI', label: 'PI' },
			{ value: 'RN', label: 'RN' },
			{ value: 'RS', label: 'RS' },
			{ value: 'RJ', label: 'RJ' },
			{ value: 'RO', label: 'RO' },
			{ value: 'RR', label: 'RR' },
			{ value: 'SC', label: 'SC' },
			{ value: 'SP', label: 'SP' },
			{ value: 'SE', label: 'SE' },
			{ value: 'TO', label: 'TO' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

